module.exports = __webpack_public_path__ + "70f85e3ca4cda5862e4d640ce1b45581.woff2";